/**
 * @file  src\mobile\pages\CreateAdForm.js
 * @brief  This file is responsible for Create want ad options section
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState, useEffect } from "react";
import BuyerList from "../../../images/buyer_listing_img.png";
import SegmentDivider from "../../../components/MemberWantAd/SegmentDivider";
import { useLocation, useNavigate } from "react-router-dom";
import { pageURLs } from "../../../constants/pageURLs";
import ProgressBarCreateAdOptions from "../../commonComponents/ProgressBarCreateAdOptions";
import { BUY } from "../../../constants/common";
import { saveMemberWantAd } from "../../../services/wantAdService";
import { generateBase64AgentId, loggedInUser } from "../../../helpers/common";
import PremiumFeatureIcon from "../../images/v2/premium-features-stars.svg";
import { getUserType } from "../../../helpers/common";
import { USER_TYPE_AGENT } from "../../../constants/common";
import { getProfileSlug } from "../../../services/v2/wantAdService";

const CreateAdForm = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location?.state;
  const isPremiumUser = state && state?.isPremiumUser;
  const [uiKey, setUIKey] = useState(null);
  const [completedPercentage, setCompletedPercentage] = useState(7);
  const [selectedOption, setSelectedOption] = useState(null);

  const [userSlug, setUserSlug] = useState("");

  const user = loggedInUser();
  const userType = getUserType();
  const agent = userType === USER_TYPE_AGENT ? true : false;
  useEffect(() => {
    // If user is not an agent, directly navigate to createWantAdResponsive
    if (!agent) {
      navigate(pageURLs?.createWantAdResponsive, {
        state: { fromCreateAdForm: true },
      });
      return;
    }
  }, [userType]);

  const handleNext = () => {
    if (selectedOption === 1) {
      // For non-premium users, redirect to update plan page
      if (!isPremiumUser) {
        navigate(pageURLs.updatePlan, {
          state: { isFromSettings: true },
        });
      } else {
        setCompletedPercentage(60);
        generateWantAdCustomLink();
      }
    } else if (selectedOption === 2) {
      navigate(pageURLs?.createWantAdResponsive, {
        state: { fromCreateAdForm: true },
      });
    }
  };

  useEffect(() => {
    getProfileSlugApi();
  }, []);

  const getProfileSlugApi = async () => {
    await getProfileSlug()
      .then((response) => {
        const responseResult = _.get(response, "result", null);
        setUserSlug(responseResult);
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  // Function to save want ad and generate custom link for buyer form
  const generateWantAdCustomLink = () => {
    const requestPayLoad = {
      isFilledByClient: true,
      isAgentAsSeller: false,
      IsSavedDraft: true,
      IsPublished: false,
      cmpldStep: 1,
      cmpldPerctg: 7,
      adType: BUY,
      isAgentCreated: true,
    };
    saveMemberWantAd(requestPayLoad)
      .then((response) => {
        const responseResult = _.get(response, "result", null);

        const agentId = user?.userInfo?.userId;
        const encodedAgentId = generateBase64AgentId(agentId);

        if (response.errorCode === 0 && responseResult) {
          const linkToShare =
            process.env.REACT_APP_BUYERLISTING_SERVICE_BASE_URL +
            "/form/" +
            userSlug;

          navigate(pageURLs?.mobileHome, {
            state: { showShareModal: true, url: linkToShare },
          });
        } else {
          console.log("Something went wrong");
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  const CreateWantAdOptionsScreen = () => {
    return (
      <>
        <div className="gitcha-main-wrapper pb-102 bg-white">
          <div className="content-wrapper content-wrapper-h-102-percent">
            <ProgressBarCreateAdOptions
              completedPercentage={completedPercentage}
              setUIKey={setUIKey}
              uiKey={uiKey}
            />
            <div className="inner-layout-content-new bg-white pl-16 pr-16 pb-0 position-relative">
              <div className="layout-content-btm-sec position-static pe-0 ps-0">
                <div className="mt-0 pt-0 mb-0 titleText">
                  How would you like to create your Want-Listing?
                </div>
              </div>
              <div className="title-selection-wrap ">
                <a
                  href={void 0}
                  onClick={() => setSelectedOption(1)}
                  className={
                    selectedOption === 1
                      ? "createAd-content-wrap mb-3 d-flex align-items-center active"
                      : "createAd-content-wrap mb-3 d-flex align-items-center"
                  }
                >
                  <span className="labelTxt">
                    <span className="premiumFeature">
                      Send a Buyer Listing Form to my client
                      {!isPremiumUser && (
                        <img
                          src={PremiumFeatureIcon}
                          alt={PremiumFeatureIcon}
                          className=""
                        />
                      )}
                    </span>
                    <span className="normalTxt">(Like a DocuSign) </span>
                  </span>
                </a>

                <div className="text-center">
                  <div className="mt-3 mb-3">
                    <img src={BuyerList} className="wdImgMob" />
                  </div>
                  <div className="buyerListxt m-auto mb-3 ">
                    {" "}
                    After your buyer submits their criteria to you via your
                    custom link, we notify you to review and post it from your
                    drafts. (Buy only)
                  </div>
                </div>

                <SegmentDivider />

                <a
                  href={void 0}
                  onClick={() => setSelectedOption(2)}
                  className={
                    selectedOption === 2
                      ? "createAd-content-wrap mb-3 d-flex align-items-center active"
                      : "createAd-content-wrap mb-3 d-flex align-items-center"
                  }
                >
                  <span className="labelTxt"> Fill out myself</span>
                </a>
              </div>
            </div>
          </div>
          <div className="inner-layout-footer-new">
            <div className="inner-btm-fixed-nav position-static">
              <div className="btn-wrap text-center pb-0 pt-0">
                <button
                  type="button"
                  className="btn btn-primary w-100 mb-3"
                  disabled={selectedOption != null ? false : true}
                  onClick={handleNext}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const renderUI = () => {
    return <CreateWantAdOptionsScreen />;
  };
  return <>{renderUI()}</>;
};

export default CreateAdForm;
